import type { PageUISection, PageUITrailResultSection } from '@alltrails/layout/utils/PageUI/pageUI';
import type { TrailResult } from '../redux/reducer';

const toDifficultyRating = (difficultyRating: string) =>
  difficultyRating && Number.isFinite(Number(difficultyRating)) ? difficultyRating : undefined;

export const toTrailResult = (section: PageUITrailResultSection): TrailResult => ({
  type: 'trail',
  id: String(section.trailId),
  ID: section.trailId, // numeric; polylines are fetched by it
  objectID: `trail-${section.trailId}`,
  name: section.name,
  slug: section.slug,
  _geoloc: section._geoloc,
  location_label: section.locationLabel,
  avg_rating: section.avgRating,
  difficulty_rating: toDifficultyRating(section.difficultyRating),
  length: section.length,
  duration_minutes: section.durationMinutes,
  num_reviews: section.numReviews,
  is_closed: section.isClosed,
  profile_photo_url: section.profilePhoto?.url
});

/**
 * The map half of PageUI: one switch over the same section union the sidebar renders, building the TrailResult[] that
 * TrailResults already draws. A section type that has nothing to put on the map returns [].
 */
export const sectionToTrailResults = (section: PageUISection): TrailResult[] => {
  switch (section.sectionType) {
    case 'trail-result':
      // Typed as required, but a trail without a trailhead can't be pinned or framed, so it is dropped
      return section._geoloc ? [toTrailResult(section)] : [];
    default:
      return [];
  }
};
